module.exports = require("@material-ui/core/StepIcon");